export function startPolling(
  fn,
  { baseMs = 30000, maxMs = 300000, factor = 2 } = {},
) {
  let delay = baseMs;
  let timer = null;
  let stopped = false;

  const run = async () => {
    if (stopped) return;
    let ok = false;
    try {
      ok = (await fn()) !== false;
    } catch {
      ok = false;
    }
    if (stopped) return;
    delay = ok ? baseMs : Math.min(delay * factor, maxMs);
    timer = setTimeout(run, delay);
  };

  run();

  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
  };
}
